angular.module("vgresiduos").factory("clientService", [
	"$http",
	"localStorageService",
	function ($http, localStorageService) {
		"use strict";

		//new apis

		function _getDecimalPlaces() {
			const client = localStorageService.get(Vgr.constants.authentication.client);

			if (client) {
				if (client.decimalPlaces) {
					return client.decimalPlaces;
				}
			} else {
				return 4;
			}
		}

		function _getPriceDecimalPlaces() {
			const client = localStorageService.get(Vgr.constants.authentication.client);

			if (client) {
				if (client.priceDecimalPlaces) {
					return client.priceDecimalPlaces;
				}
			} else {
				return 2;
			}
		}

		//core

		const _listOrganizationUnitsToLogin = function (params) {
			let parameters = "";
			if (params) {
				parameters = Vgr.util.serializeObjectToQueryString(params);
			}

			const req = {
				method: "get",
				url: Vgr.constants.coreHostUrl + "v1/organization-units-login" + parameters
			};

			return $http(req);
		};

		return {
			getDecimalPlaces: _getDecimalPlaces,
			getPriceDecimalPlaces: _getPriceDecimalPlaces,
			listOrganizationUnitsToLogin: _listOrganizationUnitsToLogin
		};
	}
]);
